module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-4 u-flex-grow-none"
  }, [_c('bar-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions,
      "width": 160,
      "height": 90
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc937582!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/charts/Bar.vue
// module id = 1810
// module chunks = 0